import Modal from 'react-modal';
import Spinner from 'components/spinner';

function ProcessingModal({ header }: { header: string | JSX.Element }): JSX.Element {
  return (
    <Modal
      isOpen={true}
      appElement={document.getElementById('root') ?? undefined}
      onAfterOpen={() => (document.body.style.overflow = 'hidden')}
      onAfterClose={() => document.body.removeAttribute('style')}
      style={{
        content: {
          position: 'static'
        }
      }}>
      <div className="w-full absolute bg-gray-100 top-0 bottom-0 right-0 left-0 flex items-center justify-center">
        <div className="bg-white shadow m-auto mt-40 py-14 px-12 text-center min-w-[416px] max-w-[568px] w-fit">
          <h3 className="text-2xl font-medium leading-6 text-gray-900 text-center">{header}</h3>
          <Spinner className="text-gray-500 mt-12" size={56} />
        </div>
      </div>
    </Modal>
  );
}

export default ProcessingModal;
